<template>
    <div style='margin: 10px'>
        <div class="container-fluid">
             <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addUserLabels.utenteLbl}}{{utenteConfigs.mandatory}}</span>
                    </div>
                    <input-w :configs="utenteConfigs">
                        <div class="col-sm-8"><input  v-model="utenteValue" type="text" id="utenteId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addUserLabels.nomeCognomeLbl}}{{nomeCognomeConfigs.mandatory}}</span>
                    </div>
                    <input-w :configs="nomeCognomeConfigs">
                        <div class="col-sm-8"><input  v-model="nomeCognomeValue" type="text" id="nomeCognomeId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addUserLabels.eMailLbl}}{{eMailConfigs.mandatory}}</span>
                    </div>
                    <input-w :configs="eMailConfigs">
                        <div class="col-sm-8"><input  v-model="eMailValue" type="text" id="eMailId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addUserLabels.telefonoLbl}}</span>
                    </div>
                    <input-w :configs="telefonoConfigs">
                        <div class="col-sm-8"><input  v-model="telefonoValue" type="text" id="telefonoId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-4">
                        <span class="align-middle">{{addUserLabels.faxLbl}}</span>
                    </div>
                    <input-w :configs="faxConfigs">
                        <div class="col-sm-8"><input  v-model="faxValue" type="text" id="faxId" class="form-control form-control-cust" /></div>
                    </input-w>
                </div>
            </div>
            
             <div class="row">
                <div class="col-md-6">&nbsp;</div>
                <div class="col-md-6">&nbsp;</div>
            </div>
            <div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-5">
                    <div class="controls col-sm-6">
                        <button class="btn btn-danger" @click.prevent="cancelClick" style="width: 100%">{{addUserLabels.annullaBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-6">
                        <button class="btn btn-primary-default" @click.prevent="confirmClick" style="width: 100%">{{addUserLabels.confermaBtnLbl}}</button>
                    </div>
                </div>
            </div>
        </div>    
    </div>    
</template>

<script>


import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import { eventBus } from "../../../eventbus";
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'

export default {
    mixins: [FormMixin],
    components: {
        InputW
    },
    data: function () {
        var vm = this;
        return {
            utenteConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
            nomeCognomeConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
            eMailConfigs: {
                id: "genericselect",
                editable: false,
                mandatory: "*"
            },
            telefonoConfigs: {
                id: "genericselect",
                editable: false
            },
            faxConfigs: {
                id: "genericselect",
                editable: false
            },
            addUserLabels: {
                utenteLbl: vm.$Jed.firstUpperTranslate('user'),
                nomeCognomeLbl: vm.$Jed.firstUpperTranslate('name')+" "+vm.$Jed.firstUpperTranslate('surname'),
                eMailLbl: vm.$Jed.firstUpperTranslate('email'),
                telefonoLbl: vm.$Jed.firstUpperTranslate('phone'),
                faxLbl: vm.$Jed.firstUpperTranslate('fax'),
                annullaBtnLbl: vm.$Jed.firstUpperTranslate("cancel"),
                confermaBtnLbl: vm.$Jed.firstUpperTranslate("confirm")

            },
            utenteValue: null,
            nomeCognomeValue: null,
            eMailValue: null,
            telefonoValue: null,
            faxValue: null,
            idUser: -1
        }
    },
    methods: {
        fillFields(data){
            this.idUser = data.id
            this.utenteValue = data.user
            this.nomeCognomeValue = data.userFullname
            this.eMailValue = data.email
            this.telefonoValue = data.phone
            this.faxValue = data.fax
        },
        cancelClick() {
            this.$emit("onCancelModifyUserEvent");
        },
        confirmClick() {
            try{
                var not_empty_value = true,
                    constraints = {
                        from: {
                            email: true
                        }
                    },
                    valid_email,
                    valid_user = true,
                    valid_fullname = true;

                function checkData(data, varName) {
                    if(validate.isEmpty(data)){
                        not_empty_value = false;
                    }
                }

                checkData(this.utenteValue,'utenteValue');
                checkData(this.nomeCognomeValue, 'nomeCognomeValue');
                checkData(this.eMailValue, 'eMailValue');
                if(this.utenteValue.length>15){
                    valid_user = false
                }
                if(this.nomeCognomeValue.length>80){
                    valid_fullname = false
                }
                if(validate({from: this.eMailValue}, constraints)){ //se è un oggetto, contiene il messaggio mail non valida
                    valid_email = (validate({from: this.eMailValue}, constraints).from[0] != 'From is not a valid email')
                }else{ //se è undefined la mail è in formato corretto
                    valid_email = true
                }

                if(not_empty_value && valid_email && valid_user && valid_fullname) {
                    let now = new Date();
                    var data = {
                        id: this.idUser, 
                        user: this.utenteValue, 
                        pwd:'', //???
                        pro: 4, //Buyer = utente acquisti
                        clientId: this.$root.token.idCliente,
                        agentId: this.$root.token.idAgente && this.$root.token.idAgente != "null" ? this.$root.token.idAgente : null,
                        flagFe: -1,
                        flagBo: 0, 
                        userFullname: this.nomeCognomeValue,
                        email: this.eMailValue,
                        phone: this.telefonoValue,                         
                        fax: this.faxValue,
                        mdt: now
                    }

                    this.$emit("onConfirmModifyUserEvent", data);

                    //svuoto i campi per un eventuale nuovo inserimento
                    this.utenteValue = null
                    this.nomeCognomeValue = null
                    this.eMailValue = null
                    this.telefonoValue = null
                    this.faxValue = null
                }else{
                    eventBus.$emit("alert", {type: "warning", message: this.$Jed.firstUpperTranslate('Insert at least: user (max 15 characters), name surname (max 80 characters) and email (must be a valid email address eg.: default@example.com)')});
                }
            }catch(err) {
                console.log(err);
            }
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ModifyUser.vue?281bc194